// en, de, fr, pt
export default {
  fr: {
    commons: {
      saveUpdate: 'Sauvegarder les modifications',
      cancelAndGoBack: 'Annuler et revenir en arrière',
      confirmPopoverMessage: 'Êtes-vous sûr(e) ?',
      confirmButtonText: 'OK',
      cancelButtonText: 'Annuler',
      defaultErrorMessage: 'Une erreur est survenue',
      fieldRequiredMessage: 'Le champs est requis',
    },
    loginPage: {
      title: 'Connectez-vous',
      usernameLabel: 'Nom utilisateur',
      passwordLabel: 'Mot de passe',
      submitButtonText: 'Se connecter',
      successMessage: 'Vous êtes connecté(e)',
      errorPassword: 'Le mot de passe est invalide',
      userDisabled: 'Cet utilisateur est désactivé',
    },
    shopAuth: {
      title: 'Saisissez l\'adresse de votre magasin',
      emailLabel: 'Adresse email du magasin',
      validEmailRequiredMessage: 'Email non valide',
      submitButtonText: 'Envoyez',
      successMessage: 'Un lien de connexion vous a été transmis par email',
    },
    shopSignInPage: {
      shopMLVerificationSuccess: 'Magasin authentifié!',
    },
    mainNav: {
      logoutMenuItem: 'Déconnexion',
      helloWorldMenuItem: 'Hello World',
      suivieConso: 'Suivie Conso',
      saisieConso: 'Saisie Conso',
      historyConso: 'Historique Conso',
      Inventory: 'Inventaire',
      saisieInventory: 'Saisie Inventaire',
      historyInventory: 'Historique Inventaire',
    },
  },
};
